import React from "react";
import styled from "styled-components";
import { Container, Section, Eyebrow } from "../components/ui/Container";
import { colors, fonts, media, radius } from "../theme";

export const ImpactStats = () => (
  <Section style={{ background: colors.brandDeep, color: "white" }}>
    <Container>
      <Grid>
        <Left>
          <Eyebrow color={colors.gold}>Real businesses</Eyebrow>
          <h2 style={{ color: "white" }}>
            <em>Capital that changes things</em> on the ground.
          </h2>
          <p>
            Every shilling matters. Every borrower has a name. We measure
            ourselves on what we change for the businesses we serve, not on
            volume alone.
          </p>
        </Left>

        <Numbers>
          <Box>
            <strong>100+</strong>
            <span>small businesses funded</span>
          </Box>
          <Box $accent>
            <strong>70%+</strong>
            <span>women led businesses</span>
          </Box>
          <Box>
            <strong>98%</strong>
            <span>Repayment rate</span>
          </Box>
          <Box>
            <strong>90%</strong>
            <span>Re borrow rate</span>
          </Box>
        </Numbers>
      </Grid>

      <Story>
        <Photo src={process.env.PUBLIC_URL + "/images/shopkeeper-portrait.jpg"} alt="Hardware seller at her shop" />
        <StoryText>
          <Eyebrow color={colors.gold}>A borrower story</Eyebrow>
          <h3>Viola, hardware seller in Kibuye Market.</h3>
          <p>
            Turned away by banks for not having collateral. Through Everpesa she
            funded her stock expansion, grew revenue, lifted her household
            income, and hired a full time employee whose family of four also
            depends on the work.
          </p>
          <Pills>
            <Mini><strong>UGX 3.7M</strong>Loan funded</Mini>
            <Mini><strong>2x</strong>Revenue growth</Mini>
            <Mini><strong>1 + 4</strong>Jobs supported</Mini>
          </Pills>
        </StoryText>
      </Story>
    </Container>
  </Section>
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 64px;
  align-items: center;
  margin-bottom: 80px;

  h2 em { color: ${colors.gold}; font-style: normal; }
  p { color: rgba(255,255,255,0.7); font-size: 17px; margin-top: 16px; }

  ${media.md} { grid-template-columns: 1fr; gap: 40px; margin-bottom: 56px; }
`;

const Left = styled.div`
  h2 { margin-top: 18px; font-family: ${fonts.display}; }
`;

const Numbers = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  min-width: 0;
`;

const Box = styled.div`
  min-width: 0;
  border-radius: ${radius.lg};
  padding: 28px;
  background: ${(p) => (p.$accent ? colors.gold : "rgba(255,255,255,0.05)")};
  border: 1px solid ${(p) => (p.$accent ? "transparent" : "rgba(255,255,255,0.08)")};
  display: flex;
  flex-direction: column;
  gap: 6px;

  strong {
    font-family: ${fonts.display};
    font-size: clamp(1.6rem, 5vw, 2.4rem);
    font-weight: 800;
    color: ${(p) => (p.$accent ? colors.brandDeep : "white")};
    letter-spacing: -0.02em;
    overflow-wrap: anywhere;
    line-height: 1.05;
  }
  span {
    font-size: 13.5px;
    color: ${(p) => (p.$accent ? "rgba(0,15,61,0.7)" : "rgba(255,255,255,0.7)")};
  }

  ${media.sm} { padding: 20px; }
`;

const Story = styled.div`
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 40px;
  align-items: center;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  padding: 32px;
  border-radius: ${radius.xl};

  h3 { color: white; margin-top: 14px; font-family: ${fonts.display}; font-size: clamp(1.4rem, 2.4vw, 1.8rem); }
  p { color: rgba(255,255,255,0.75); margin-top: 14px; font-size: 16px; }

  ${media.md} { grid-template-columns: 1fr; gap: 24px; padding: 22px; }
`;

const Photo = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: ${radius.lg};
`;

const StoryText = styled.div``;

const Pills = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const Mini = styled.div`
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.14);
  padding: 10px 14px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  font-size: 12.5px;
  color: rgba(255,255,255,0.6);
  strong {
    color: ${colors.gold};
    font-family: ${fonts.display};
    font-size: 17px;
    font-weight: 700;
  }
`;
